import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import { getCookie } from "../../utils/cookie";
var ua = typeof window === 'undefined' ? '' : window.navigator.userAgent;
export var getUA = function getUA() {
  return ua;
};
export var getClientType = function getClientType() {
  var browserType = '';
  if (ua.match(/(Opera|OPR)/)) {
    browserType = 'Opera';
  } else if (ua.match(/Firefox/)) {
    browserType = 'Firefox';
  } else if (ua.match(/Chrome/)) {
    browserType = 'Chrome';
  } else if (ua.match(/Safari/)) {
    browserType = 'Safari';
  } else if (ua.match(/Trident/)) {
    browserType = 'IE';
  } else if (ua.match(/Edge/)) {
    browserType = 'Edge';
  }

  // console.log('browserType', browserType);
  return browserType;
};
export var getOS = function getOS() {
  var system = '未知操作系统';
  if (ua.indexOf('Windows') >= 0) {
    system = 'Windows';
  } else if (ua.indexOf('Mac') >= 0) {
    system = 'Mac';
  } else if (ua.indexOf('X11') >= 0) {
    system = 'Unix';
  } else if (ua.indexOf('Android') >= 0) {
    system = 'Android';
  } else if (ua.indexOf('iPhone') >= 0) {
    system = 'iPhone';
  } else if (ua.indexOf('OpenHarmony') >= 0) {
    system = 'HarmonyOS';
  }
  return system;
};
export var getOsVersion = function getOsVersion() {
  var version = '';
  if (ua.indexOf('Mac OS X') > -1) {
    // mac
    var regStr_saf = /OS X [\d._]*/gi;
    var verinfo = ua.match(regStr_saf);
    version = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
  } else if (ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1) {
    // andr
    version = ua.substr(ua.indexOf('Android') + 8, ua.indexOf(';', ua.indexOf('Android')) - ua.indexOf('Android') - 8);
  } else {
    // windows
    var userAgent = ua.toLowerCase();
    if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      version = 'Windows XP';
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      version = 'Windows Vista';
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      version = 'Windows 7';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      version = 'Windows 8';
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      version = 'Windows 8.1';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      version = 'Windows 10';
    } else {
      version = 'Unknown';
    }
  }
  return version;
};
export var getPageType = function getPageType() {
  var needMergeRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var needPathName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  try {
    // 项目名称 等价于 hostname， 页面即 pathname+hash
    var _window$location = window.location,
      hostname = _window$location.hostname,
      pathname = _window$location.pathname,
      hash = _window$location.hash;
    var _path = '';
    var _hash = '';
    if (pathname === '/') {
      _path = '';
    } else {
      _path = pathname.replaceAll('--', '__');
    }
    if (hash) {
      // 去掉 hash 中的 ? 参数
      _hash = hash.replace(/\?.*/, '').replace(/^#\//, '');

      // 合并动态 :id 路由
      try {
        // console.log('needMergeRoute', needMergeRoute)
        if (needMergeRoute) {
          _hash = _hash.split('/').map(function (v) {
            if (shouldReplaceHashToId(v)) return ':id';
            if (/^[0-9]{1,}$/.test(v)) return ':id';
            if (v === 'undefined') return ':id';
            return v;
          }).join('/');
        }
      } catch (error) {}
    }
    // 限制字段长度
    var p = '';
    // needPathName为true则拼接pathname否则不拼接
    if (needPathName) {
      p = "".concat(hostname, "--").concat(_path).concat(_hash).slice(0, 200);
    } else {
      p = "".concat(hostname, "--").concat(_hash).slice(0, 200);
    }
    return p;
  } catch (e) {
    return '';
  }
};
export var getPageUrl = function getPageUrl() {
  try {
    var _window$location2 = window.location,
      protocol = _window$location2.protocol,
      hostname = _window$location2.hostname,
      pathname = _window$location2.pathname,
      hash = _window$location2.hash;
    var url = "".concat(protocol, "//").concat(hostname).concat(pathname).concat(hash && hash.split('?')[0]);
    return url;
  } catch (e) {
    return '';
  }
};

/**
 * 如果一段url中的数字占比超过80%则替换成:id
 */
export var shouldReplaceHashToId = function shouldReplaceHashToId(v) {
  var digitCount = (v.match(/\d/g) || []).length; // 计算数字的数量
  var digitRatio = digitCount / v.length; // 计算数字的比例
  return digitRatio > 0.8; // 如果数字比例超过 80%，返回 true
};

/**
 * 获取用户 uid
 * 特殊处理 某些系统
 */
export var getCookieId = function getCookieId() {
  var uid = '';
  var code = getCookie('sso_company_code');
  code = code !== undefined ? '__' + code : '';

  // 质检系统  gsso_uid
  if (uid = getCookie('gsso_uid')) {
    return uid + code;
  }

  // 乾数据
  if (uid = getCookie('uid')) {
    return uid + code;
  }

  // 企微认证
  if (uid = getCookie('sso_uid')) {
    return uid + code;
  }
  return getCookie('idzz') || getCookie('id58') || '';
};

// 获取浏览器 timeOrigin
export var getBrowserTimeOrigin = function getBrowserTimeOrigin() {
  var _window;
  if (!((_window = window) !== null && _window !== void 0 && (_window = _window.performance) !== null && _window !== void 0 && _window.now)) return;
  var performance = window.performance;
  var timeOrigin = performance.timeOrigin ? performance.timeOrigin : performance.timing.navigationStart;
  return timeOrigin;
};
export var fix = function fix(t) {
  return Math.min(1e5, Math.max(parseInt(t === null || t === void 0 ? void 0 : t.toString(), 10) || 0, 0));
};
export var waitTime = function waitTime() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (res) {
    return setTimeout(res, time);
  });
};
export var setStorage = function setStorage(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // 满了就清空，避免影响业务
    window.localStorage.removeItem(key);
  }
};
export var getStorage = function getStorage(key) {
  try {
    window.localStorage.getItem(key);
  } catch (error) {}
};
export var removeStorage = function removeStorage(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {}
};
export var generateUUId = function generateUUId() {
  var _crypto$randomUUID, _crypto;
  return ((_crypto$randomUUID = (_crypto = crypto).randomUUID) === null || _crypto$randomUUID === void 0 ? void 0 : _crypto$randomUUID.call(_crypto)) || '';
};
var _value = /*#__PURE__*/new WeakMap();
var RefImpl = /*#__PURE__*/function () {
  function RefImpl(val) {
    _classCallCheck(this, RefImpl);
    _classPrivateFieldInitSpec(this, _value, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _value, val);
  }
  _createClass(RefImpl, [{
    key: "value",
    get: function get() {
      return _classPrivateFieldGet(this, _value);
    },
    set: function set(val) {
      _classPrivateFieldSet(this, _value, val);
    }
  }]);
  return RefImpl;
}();
export var ref = function ref(val) {
  return new RefImpl(val);
};

// requestIdleInterval 模拟 interval 定时器
export var requestIdleInterval = function requestIdleInterval() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60000;
  var timerId = null;
  var lastRan = null;
  var loop = function loop() {
    // 首次运行
    if (lastRan === null) {
      lastRan = Date.now();
      callback(Date.now());
      timerId = requestIdleCallback(loop);
    } else {
      var timeSinceLastRan = Date.now() - lastRan;
      if (timeSinceLastRan >= interval) {
        callback(Date.now());
        lastRan = Date.now();
      }
      timerId = requestIdleCallback(loop);
    }
  };

  // 首次启动
  timerId = requestIdleCallback(loop);

  // 返回一个函数以清除这个模拟的定时器
  return function () {
    cancelIdleCallback(timerId);
    timerId = null;
    lastRan = null;
  };
};
export var isDomFocus = function isDomFocus() {
  return document.hasFocus();
};